import { useMemo, useEffect } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { Controller } from "react-hook-form";
import { fetchZonesDD } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";

const ZoneDropdownMultiSelector = ({
  errors,
  control,
  setValue,
  watch,
  mappedData,
  login
}) => {
  const selectedZones = watch("zone_id");

  const { data: Zones, isLoading, error, refetch } = useQuery(
    ["zones"],
    () => fetchZonesDD({ ...login }),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME
    }
  );

  useEffect(() => {
    if (login) refetch();
  }, [login, refetch]);

  const optionsList = useMemo(
    () =>
      Zones?.data?.zone_data?.map((data) => ({
        value: data.zone_id,
        label: data.zone_name
      })) || [],
    [Zones]
  );

  const options = mappedData
    ? optionsList.filter((option) => !mappedData.includes(option.label))
    : optionsList;

    useEffect(() => {
    if (Zones && selectedZones?.length !== 0  ) {
      const defaultValues = mappedData?.map((label) =>
        optionsList.find((option) => option.value === label?.zone_id)
      );

      if (defaultValues) {
        const defaultIds = defaultValues.map((opt) => opt?.value);
        setValue("zone_id", defaultIds);
        setValue("zone_name", defaultValues.map((opt) => opt?.label));
      }
    }
  }, [mappedData, optionsList, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Zone Data</div>;

  return (
    <Controller
      name="zone_id"
      control={control}
      rules={{ required: "Zone selection is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isMulti
          isClearable
          placeholder="Select Zones"
          menuPortalTarget={document.body}
          value={options.filter((option) =>
            selectedZones?.includes(option.value)
          )}
          onChange={(selectedOptions) => {
            const values = selectedOptions
              ? selectedOptions.map((option) => option.value)
              : [];
            const labels = selectedOptions
              ? selectedOptions.map((option) => option.label)
              : [];

            field.onChange(values);
            setValue("zone_id", values);
            setValue("zone_name", labels);
          }}
          className={`react-select-container ${
            errors.zone_id ? "is-invalid" : ""
          }`}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              minHeight: "42px",
              maxHeight: "auto",
              overflowY: "auto"
            }),
            valueContainer: (base) => ({
              ...base,
              maxHeight: "42px",
              overflowY: "auto"
            }),
            multiValue: (base) => ({
              ...base,
              maxWidth: "100%"
            })
          }}
        />
      )}
    />
  );
};
export default ZoneDropdownMultiSelector;
